import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { useAppSelector } from "../../store/hooks";
import axiosInstance from "../../api/axiosInstance";
import "./ForgotPassword.css";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const PHONE_MAX_DIGITS = 15;

const ForgetPass = () => {
  return (
    <div className="signup_modal">
      <div className="signUpUi">
        <UsernameVerfication />
      </div>

      {/* <div className="disclaimer-ctn-fg">
        <div className="disclaimer-ctn-text-fg text-white text-center">
          Please log in to continue.
        </div>
      </div> */}
    </div>
  );
};

function UsernameVerfication() {
  const [option, setOption] = useState("Username");

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [otpTimer, setOtpTimer] = useState(null);
  const [orderID, setOrderID] = useState("");

  const [userName, setUserName] = useState("");
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("");

  const [otpSend, setOtpSend] = useState(false);
  const [otpEnterFields, setOtpEnterFields] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);

  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [conPassword, setConPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  const nav = useNavigate();

  const [error, setError] = useState({
    username: "",
    phone: "",
    otp: "",
    password: "",
    confirmPassword: "",
    api: "",
  });

  const [successMessage, setSuccessMessage] = useState("");

  const logoUrl = useAppSelector((state) => state.logo?.logoUrl);
  const logoLoading = useAppSelector((state) => state.logo?.loading);

  const getPhoneDigits = (value) => {
    return String(value || "").replace(/\D/g, "");
  };

  const clearErrors = () => {
    setError({
      username: "",
      phone: "",
      otp: "",
      password: "",
      confirmPassword: "",
      api: "",
    });
    setSuccessMessage("");
  };

  const updateError = (key, value) => {
    setError((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  /**
   * OTP TIMER
   */
  useEffect(() => {
    if (otpTimer === null || otpTimer <= 0) {
      return;
    }

    const timer = setInterval(() => {
      setOtpTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return null;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [otpTimer]);

  /**
   * RESET FORM WHEN USER CHANGES USERNAME / MOBILE
   */
  const handleOptionChange = (item) => {
    const value = item;

    setOption(value);

    setUserName("");
    setPhone("");
    setCountry("");
    setOtp("");
    setOrderID("");

    setOtpSend(false);
    setOtpEnterFields(false);
    setIsOtpVerified(false);
    setOtpTimer(null);

    setPassword("");
    setConPassword("");

    clearErrors();
  };

  /**
   * VALIDATE SEND OTP FORM
   */

  const validateSendOtp = () => {
    let isValid = true;

    clearErrors();

    if (option === "Username") {
      const username = userName.trim();

      if (!username) {
        toast.error("Username is required.");
        isValid = false;
      } else if (username.length < 4 || username.length > 15) {
        toast.error("Username must be between 4 and 15 characters.");
        isValid = false;
      } else if (!/^[a-zA-Z0-9]+$/.test(username)) {
        toast.error("Username can contain only letters and numbers.");
        isValid = false;
      }
    } else {
      const digits = getPhoneDigits(phone);

      if (!digits) {
        toast.error("Mobile number is required.");
        isValid = false;
      } else if (digits.length <= (country?.dialCode?.length || 0)) {
        toast.error("Please enter a valid mobile number.");
        isValid = false;
      }
    }

    return isValid;
  };

  /**
   * SEND OTP
   */
  const sendOTP = async () => {
    if (!validateSendOtp()) {
      return;
    }

    setLoading(true);
    clearErrors();
    setIsOtpVerified(false);

    try {
      const dialCode = country?.dialCode?.toString() || "91";

      const digits = getPhoneDigits(phone).slice(0, PHONE_MAX_DIGITS);

      const mobileWithoutCode =
        option === "Phone number"
          ? digits.startsWith(dialCode)
            ? digits.slice(dialCode.length)
            : digits
          : "";

      const payload = {
        country_code: `+${dialCode}`,
      };

      if (option === "Username") {
        payload.user_name = userName.trim();
      } else {
        payload.mobile = mobileWithoutCode;
      }

      const response = await axiosInstance.post(
        "/whatsapp/resetPassword",
        payload,
        {
          headers: {
            Authorization: "Basic YXBwbGljYXRpb246c2VjcmV0",
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
        },
      );

      if (response?.status) {
        const orderId = response.data?.orderId || "";
        const expiry = Number(response?.otp_expiry_time ?? 60);

        setOrderID(orderId);
        setOtpSend(true);
        setOtpEnterFields(true);
        setOtpTimer(expiry);
        setOtp("");

        toast.success(
          response?.msg ||
            "OTP has been successfully sent to your WhatsApp number.",
        );
      } else {
        setOtpSend(false);

        toast.error(response?.msg || "Unable to send OTP. Please try again.");
      }
    } catch (err) {
      setOtpSend(false);

      toast.error(
        err?.response?.data?.msg ||
          "Something went wrong while sending OTP. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };
  const resendOTP = async () => {
    if (!orderID || otpTimer !== null) {
      return;
    }

    setLoading(true);
    clearErrors();

    try {
      const response = await axiosInstance.post(
        "/whatsapp/resendResetPasswordOtp",
        {
          orderId: orderID,
        },
      );

      if (response?.data?.status) {
        const expiry = Number(response?.data?.otp_expiry_time ?? 60);

        setOtpTimer(expiry);
        setOtpEnterFields(true);
        setOtp("");
        setIsOtpVerified(false);

        setOrderID(response?.data?.data?.orderId || orderID);

        toast.success(
          response?.data?.msg ||
            "OTP has been successfully resent to your WhatsApp number.",
        );
      } else {
        toast.error(
          response?.data?.msg || "Unable to resend OTP. Please try again.",
        );
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.msg || "Something went wrong while resending OTP.",
      );
    } finally {
      setLoading(false);
    }
  };

  /**
   * VALIDATE OTP
   */
  const validateOtp = async () => {
    if (verifyLoading) {
      return;
    }

    const enteredOtp = otp?.toString().trim();

    if (!enteredOtp) {
      toast.error("Please enter OTP.");
      return;
    }

    if (!orderID) {
      toast.error("OTP session expired. Please request a new OTP.");
      return;
    }

    if (enteredOtp.length < 4) {
      toast.error("Please enter a valid OTP.");
      return;
    }

    setVerifyLoading(true);

    setSuccessMessage("");

    try {
      const payload = {
        orderId: orderID,
        otp: enteredOtp,
      };

      const response = await axiosInstance.post(
        "/whatsapp/verifyResetPasswordOtp",
        payload,
        {
          headers: {
            Authorization: "Basic YXBwbGljYXRpb246c2VjcmV0",
            "Content-Type": "application/json",
          },
        },
      );

      if (response?.status) {
        setIsOtpVerified(true);

        toast.success(response?.msg || "OTP has been verified successfully.");
      } else {
        setIsOtpVerified(false);

        toast.error(response?.msg || "Invalid OTP. Please try again.");
      }
    } catch (err) {
      setIsOtpVerified(false);

      toast.error(
        err?.response?.data?.msg || "Something went wrong while verifying OTP.",
      );
    } finally {
      setVerifyLoading(false);
    }
  };

  /**
   * SEND / RESEND OTP BUTTON
   */
  const handleSendOtp = (e) => {
    e.preventDefault();

    if (otpSend) {
      resendOTP();
    } else {
      sendOTP();
    }
  };

  /**
   * VALIDATE PASSWORD
   */
  const validatePassword = () => {
    let isValid = true;

    if (!password) {
      toast.error("New password is required.");
      isValid = false;
    } else if (password.length < 6) {
      toast.error("Password must be at least 6 characters.");
      isValid = false;
    }

    if (!conPassword) {
      toast.error("Please confirm your password.");
      isValid = false;
    } else if (password !== conPassword) {
      toast.error("Passwords do not match.");
      isValid = false;
    }

    return isValid;
  };

  /**
   * RESET PASSWORD
   */
  const resetPassword = async () => {
    if (!isOtpVerified) {
      return;
    }

    if (!validatePassword()) {
      return;
    }

    setResetLoading(true);
    setSuccessMessage("");

    try {
      const data = {
        orderId: orderID,
        newPassword: password,
        confirmPassword: conPassword,
      };

      const response = await axiosInstance.post("/whatsapp/setPassword", data, {
        headers: {
          Authorization: "Basic YXBwbGljYXRpb246c2VjcmV0",
          "Content-Type": "application/json",
        },
      });

      if (response?.status) {
        toast.success(
          response?.msg || "Your password has been updated successfully.",
        );

        setPassword("");
        setConPassword("");

        setTimeout(() => {
          nav("/");
        }, 1000);
      } else {
        toast.error(
          response?.msg || "Unable to reset password. Please try again.",
        );
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.msg ||
          "Something went wrong while resetting password.",
      );
    } finally {
      setResetLoading(false);
    }
  };

  const handleReset = (e) => {
    e.preventDefault();
    resetPassword();
  };

  return (
    <div className="container-fluid">
      <div className="col-12 text-center pt-3">
        {logoUrl && (
          <img
            className="img-fluid main-logo"
            src={
              logoUrl ||
              (logoLoading
                ? ""
                : "https://speedcdn.io/assets/logos/reddybook.live.png")
            }
            style={{ width: "150px" }}
            alt="Logo"
          />
        )}
      </div>

      {/* SEND OTP FORM */}
      <form
        className="col-sm-12 mx-auto"
        id="signup_form"
        onSubmit={handleSendOtp}
        autoComplete="off"
      >
        <div className="select-input .pwd-field">
          {/* <select
            className="option-selection"
            value={option}
            onChange={handleOptionChange}
            disabled={otpEnterFields}
          >
            <option value="Username">User Id</option>
            <option value="Phone number">Mobile</option>
          </select> */}

          <div className="d-flex align-items-center my-2 mb-3 justify-content-between new-middle-menus">
            <div
              onClick={() => handleOptionChange("Username")}
              className={`text-center ${option === "Username" ? "hightlight-menu" : ""} p-2 w-100 text-white1`}
            >
              User Id
            </div>
            <div
              onClick={() => handleOptionChange("Phone number")}
              className={`text-center ${option === "Phone number" ? "hightlight-menu" : ""} p-2 w-100 text-white1`}
            >
              Mobile
            </div>
          </div>

          <div className="w-78">
            {option === "Username" ? (
              <div className="form-group">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="username"
                    name="username"
                    placeholder="Username 4 To 15 Alphanumeric"
                    value={userName}
                    disabled={otpEnterFields}
                    onChange={(e) => {
                      setUserName(e.target.value);
                    }}
                  />
                </div>

                {error.username && (
                  <small className="text-danger d-block mt-1">
                    {error.username}
                  </small>
                )}
              </div>
            ) : (
              <div className="form-group">
                <div className="input-group d-flex align-items-stretch flex-nowrap">
                  <div className="flex-grow-1">
                    <PhoneInput
                      country="in"
                      containerClassName="mb-0"
                      inputClassName="w-100"
                      placeholder="Enter Phone Number"
                      preferredCountries={[
                        "in",
                        "ae",
                        "th",
                        "pk",
                        "np",
                        "lk",
                        "gb",
                      ]}
                      value={phone}
                      onChange={(value, countryData) => {
                        const digits = getPhoneDigits(value);

                        if (digits.length <= PHONE_MAX_DIGITS) {
                          setPhone(value);
                        }

                        setCountry(countryData);
                      }}
                      disabled={otpEnterFields}
                      countryCodeEditable={true}
                      inputStyle={{
                        width: "100%",
                        backgroundColor: "#d3d3d3",
                      }}
                    />
                  </div>
                </div>

                {error.phone && (
                  <small className="text-danger d-block mt-1">
                    {error.phone}
                  </small>
                )}
              </div>
            )}
          </div>
        </div>

        {error.api && (
          <small className="error-msg text-danger mt-1">{error.api}</small>
        )}

        {successMessage && (
          <small className="text-success mt-1 text-[10px]">
            {successMessage}
          </small>
        )}

        <button
          className="bg-transparent text-right text_send border-0 text-white text-decoration-underline px-0"
          type="submit"
          disabled={loading || (otpSend && otpTimer !== null)}
        >
          {loading
            ? "Please wait..."
            : otpSend
              ? `Resend Otp${otpTimer !== null ? ` ${otpTimer} Seconds` : ""}`
              : "Send Otp"}
        </button>
      </form>

      {/* OTP + PASSWORD FORM */}
      <form
        className="forgot-pwd-form-ctn pt-0"
        onSubmit={handleReset}
        autoComplete="off"
      >
        {/* OTP */}
        <div className="form-group">
          <div className="input-group">
            <input
              className="form-control"
              placeholder="Enter Otp"
              type="text"
              name="otp"
              value={otp}
              autoFocus
              disabled={!otpSend || verifyLoading}
              maxLength={6}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");

                setOtp(value);

                setSuccessMessage("");
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  validateOtp();
                }
              }}
            />
          </div>

          {error.otp && (
            <small className="text-danger d-block mt-1">{error.otp}</small>
          )}

          {isOtpVerified && (
            <small className="text-success d-block mt-1">
              OTP verified successfully.
            </small>
          )}

          {otpSend && !isOtpVerified && (
            <button
              type="button"
              className="bg-transparent text_send border-0 text-white text-decoration-underline px-0 mt-1"
              onClick={validateOtp}
              disabled={verifyLoading}
            >
              {verifyLoading ? "Verifying..." : "Verify OTP"}
            </button>
          )}
        </div>

        {/* NEW PASSWORD */}
        <div className="form-group">
          <div className="input-group">
            <input
              className="form-control"
              type={showNewPassword ? "text" : "password"}
              name="newPassword"
              disabled={!isOtpVerified}
              placeholder="Enter New Password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />

            <button
              type="button"
              className="btn"
              style={{
                backgroundColor: "#ffffff",
                color: "#000000",
                border: "1px solid #ffffff",
                zIndex: 1,
              }}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => setShowNewPassword((v) => !v)}
              aria-label={showNewPassword ? "Hide password" : "Show password"}
              title={showNewPassword ? "Hide password" : "Show password"}
            >
              {showNewPassword ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7S2 12 2 12Z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M10.733 5.076A10.744 10.744 0 0 1 12 5c7 0 10 7 10 7a18.893 18.893 0 0 1-3.392 4.916" />
                  <path d="M14.084 14.158A3 3 0 0 1 9.84 9.916" />
                  <path d="M17.479 17.499A10.75 10.75 0 0 1 12 19c-7 0-10-7-10-7a18.827 18.827 0 0 1 4.231-5.568" />
                  <path d="M2 2l20 20" />
                </svg>
              )}
            </button>
          </div>

          {error.password && (
            <small className="text-danger d-block mt-1">{error.password}</small>
          )}
        </div>

        {/* CONFIRM PASSWORD */}
        <div className="form-group">
          <div className="input-group">
            <input
              className="form-control"
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              disabled={!isOtpVerified}
              value={conPassword}
              placeholder="Enter Confirm Password"
              onChange={(e) => {
                setConPassword(e.target.value);
              }}
            />

            <button
              type="button"
              className="btn"
              style={{
                backgroundColor: "#ffffff",
                color: "#000000",
                border: "1px solid #ffffff",
                zIndex: 1,
              }}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => setShowConfirmPassword((v) => !v)}
              aria-label={
                showConfirmPassword ? "Hide password" : "Show password"
              }
              title={showConfirmPassword ? "Hide password" : "Show password"}
            >
              {showConfirmPassword ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7S2 12 2 12Z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M10.733 5.076A10.744 10.744 0 0 1 12 5c7 0 10 7 10 7a18.893 18.893 0 0 1-3.392 4.916" />
                  <path d="M14.084 14.158A3 3 0 0 1 9.84 9.916" />
                  <path d="M17.479 17.499A10.75 10.75 0 0 1 12 19c-7 0-10-7-10-7a18.827 18.827 0 0 1 4.231-5.568" />
                  <path d="M2 2l20 20" />
                </svg>
              )}
            </button>
          </div>

          {error.confirmPassword && (
            <small className="text-danger d-block mt-1">
              {error.confirmPassword}
            </small>
          )}
        </div>

        {error.api && (
          <span className="error-msg text-danger d-block mt-1">
            {error.api}
          </span>
        )}

        <button
          className="btn btn-primary mt-1"
          type="submit"
          disabled={!isOtpVerified || resetLoading}
        >
          {resetLoading ? "Resetting..." : "Reset Password"}
        </button>
      </form>
    </div>
  );
}

export default ForgetPass;
